import type { SubscriptionTier, FeatureSet } from '@/types';

export const TIER_FEATURES: Record<SubscriptionTier, FeatureSet> = {
  free: {
    limits: {
      classes: 2,
      studentsPerClass: 25,
      assessmentsPerMonth: 5,
      questionBanks: 3,
      aiGradingsPerMonth: 0,
    },
    features: {
      multipleChoice: true,
      shortAnswer: false,
      essayQuestions: false,
      aiGrading: false,
      customRubrics: false,
      advancedAnalytics: false,
      exportData: false,
      questionSharing: false,
      multiTeacher: false,
      adminDashboard: false,
    },
  },

  pro: {
    limits: {
      classes: Infinity,
      studentsPerClass: 50,
      assessmentsPerMonth: Infinity,
      questionBanks: Infinity,
      aiGradingsPerMonth: 100,
    },
    features: {
      multipleChoice: true,
      shortAnswer: true,
      essayQuestions: true,
      aiGrading: true,
      customRubrics: true,
      advancedAnalytics: true,
      exportData: true,
      questionSharing: false,
      multiTeacher: false,
      adminDashboard: false,
    },
  },

  school: {
    limits: {
      classes: Infinity,
      studentsPerClass: Infinity,
      assessmentsPerMonth: Infinity,
      questionBanks: Infinity,
      aiGradingsPerMonth: 500,
    },
    features: {
      multipleChoice: true,
      shortAnswer: true,
      essayQuestions: true,
      aiGrading: true,
      customRubrics: true,
      advancedAnalytics: true,
      exportData: true,
      questionSharing: true,
      multiTeacher: true,
      adminDashboard: true,
    },
  },

  // Pilot tier - features resolved dynamically from subscription.pilot.features
  // Default to 'pro' level features
  pilot: {
    limits: {
      classes: Infinity,
      studentsPerClass: 50,
      assessmentsPerMonth: Infinity,
      questionBanks: Infinity,
      aiGradingsPerMonth: 100,
    },
    features: {
      multipleChoice: true,
      shortAnswer: true,
      essayQuestions: true,
      aiGrading: true,
      customRubrics: true,
      advancedAnalytics: true,
      exportData: true,
      questionSharing: false,
      multiTeacher: false,
      adminDashboard: false,
    },
  },

  // Admin tier - full unlimited access
  admin: {
    limits: {
      classes: Infinity,
      studentsPerClass: Infinity,
      assessmentsPerMonth: Infinity,
      questionBanks: Infinity,
      aiGradingsPerMonth: Infinity,
    },
    features: {
      multipleChoice: true,
      shortAnswer: true,
      essayQuestions: true,
      aiGrading: true,
      customRubrics: true,
      advancedAnalytics: true,
      exportData: true,
      questionSharing: true,
      multiTeacher: true,
      adminDashboard: true,
    },
  },
};

// Helper to get display name for tiers
export const TIER_DISPLAY_NAMES: Record<SubscriptionTier, string> = {
  free: 'Free',
  pro: 'Pro',
  school: 'School',
  pilot: 'Pilot (Beta)',
  admin: 'Administrator',
};

// Helper to get pricing
export const TIER_PRICING: Record<SubscriptionTier, { monthly: number; yearly: number }> = {
  free: { monthly: 0, yearly: 0 },
  pro: { monthly: 19, yearly: 190 },
  school: { monthly: 0, yearly: 0 }, // Custom pricing
  pilot: { monthly: 0, yearly: 0 }, // Free during trial
  admin: { monthly: 0, yearly: 0 }, // N/A
};
